<!-- 문의 답변달기 -->
<template>
  <div>
    <admin-box-item title="답변달기" :useTab="false">
      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item label="제목">
            <div>{{ value.qnaItem.title }}</div>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="문의내용">
            <div>{{ value.qnaItem.content }}</div>
          </admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="답변달기">
            <textarea class="textarea" rows="3" cols="10" v-model="value.qnaItem[value.paramName]"></textarea>
          </admin-form-item>
        </div>
      </div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="saveQna">확인</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";

  export default {
    props: ['data'],
    components: {
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: {
          qnaItem:{

          },
          url:'',
          paramName:''
        }
      }
    },
    computed: {
    },
    created() {
      this.value = this.data;
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      saveQna(){
        if(!this.value.qnaItem[this.value.paramName]){
          this.toast('답변을 입력해주세요.');
          return;
        }
        let paramData = '';
        if(this.value.paramName==='answer_content'){
          paramData = {
            answer_content: this.value.qnaItem.answer_content
          }
        }
        else if(this.value.paramName==='content'){
          paramData = {
            content: this.value.qnaItem.content
          }
        }
        else if(this.value.paramName==='comment'){
          paramData = {
            comment: this.value.qnaItem.comment
          }
        }
        this.$axios.patch(this.getUrl(this.value.url), paramData
        ).then(res=>{
          if(res.status===200){
            this.toast('완료되었습니다.');
            this.$store.commit('closeModal');
          }
        })
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
